// src/hooks/useStatusCatalog.js
//
// Catálogo de estados para mostrar etiquetas de color. Una lectura por sesión
// (cache de módulo); invalidateStatusCatalog() la fuerza de nuevo tras editar.
import { useEffect, useState } from 'react';
import { getStatusCatalog } from '../services/statusCatalogService';
import { DEFAULT_STATUSES } from '../config/claimStatuses';

let cache = null;
let inflight = null;
const listeners = new Set();

export const invalidateStatusCatalog = () => {
  cache = null;
  inflight = null;
  listeners.forEach(listener => listener());
};

const load = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) inflight = getStatusCatalog().then(items => { cache = items; return items; }).catch(() => DEFAULT_STATUSES);
  return inflight;
};

export default function useStatusCatalog() {
  const [catalog, setCatalog] = useState(cache || DEFAULT_STATUSES);
  useEffect(() => {
    let active = true;
    const refresh = () => load().then(items => { if (active) setCatalog(items); });
    refresh();
    listeners.add(refresh);
    return () => { active = false; listeners.delete(refresh); };
  }, []);
  return catalog;
}
